module.exports = __webpack_public_path__ + "img/ir.3b7abfd6.svg";